import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import BlogDetail from 'components/BlogDetail'
import { StoriesStore } from 'stores/stories'
import { useStoryPageView, useStore } from 'hooks'
import { getServerSideWrapper } from 'utils/data-fetching'
import { storyCanonicalRedirect } from 'utils/http'
import THEME from 'utils/theme'
import ConfigStore from 'stores/config'

const BlogDetailPage = ({ story, global }) => {
  useStore(StoriesStore, { current: story })
  useStore(ConfigStore, { current: global.config })

  useStoryPageView(story)

  return (
    <SiteLayout background={THEME.COLORS.BACKGROUND_GRAY} showNavBarCTA useAvailableEventLogo={false}>
      <Head story={story} />
      <BlogDetail />
    </SiteLayout>
  )
}

export const getServerSideProps = getServerSideWrapper(async ({ params, ...ctx }) => {
  try {
    const { id } = params
    const story = await StoriesStore().findById(id)
    storyCanonicalRedirect(story, ctx)
    return {
      story
    }
  } catch (errr) {
    console.log(errr)
  }
})

export default BlogDetailPage
